import "./LandingPageNav.css";

const SECTIONS = [
  { id: "about", label: "О сервисе" },
  { id: "products", label: "Интерфейс" },
  { id: "launch", label: "Запуск" },
  { id: "pricing", label: "Тарифы" },
  { id: "comparison", label: "Сравнение" },
  { id: "analytics", label: "Аналитика" },
  { id: "cases", label: "Примеры" },
  { id: "faq", label: "Вопросы" },
];

export default function LandingPageNav({ variant = "inline" }) {
  return (
    <nav
      className={`landing-page-nav landing-page-nav--${variant}`}
      aria-label="Разделы главной страницы"
    >
      <div className="landing-page-nav__inner">
        {SECTIONS.map(({ id, label }) => (
          <a key={id} href={`#${id}`} className="landing-page-nav__link">
            {label}
          </a>
        ))}
      </div>
    </nav>
  );
}
